import { defineFcm } from '../shared/factory';

export const FCM_BLOCKED_SIGNATURE_EXPORT = defineFcm('blocked_signature_export')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'export-service',
		context: 'export-svc',
		description: 'Used to configure which countries have signature exports disabled.',
	});
